var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-width"},[_c('v-divider',{staticClass:"pt-0 pb-9"}),_vm._t("default",function(){return [_vm._v(" Oops, this page doesn't seem to exist! ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }